<template>
  <div class="city_update">
    <tabs v-if="isReady">
      <tab name="Genel">
        <div class="row">
          <div class="col-md-12">
            <div class="widget">
              <div class="form-elements-sec">
                <div class="widget-title">
                  <h3>İlçe Düzenle ({{ name }})</h3>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="name">İlçe İsmi</label>
                      <input type="text" class="form-control custom-input" v-model="name">
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="slug">SEF Link</label>
                      <input type="text" class="form-control custom-input" v-model="slug">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </tab>
      <tab name="Listeleme">
        <div class="row">
          <div class="col-md-12">
            <div class="widget">
              <div class="form-elements-sec">
                <div class="widget-title">
                  <h3>İlçe Düzenle ({{ name }})</h3>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="title">Başlık</label>
                      <input class="form-control custom-input" v-model="title">
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="keywords">Meta Keywords</label>
                      <textarea class="form-control custom-input" v-model="keywords" rows="5"></textarea>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="description">Meta Description</label>
                      <textarea class="form-control custom-input" v-model="description" rows="5"></textarea>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="spot">Spot</label>
                      <vue-editor :editorToolbar="customToolbar" v-model="spot" class="editor"></vue-editor>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="list_seo">İlçe Description</label>
                      <vue-editor :editorToolbar="customToolbar" v-model="list_seo" class="editor"></vue-editor>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </tab>
      <tab name="Erkek Öğr. SEO">
        <div class="row">
          <div class="col-md-12">
            <div class="widget">
              <div class="form-elements-sec">
                <div class="widget-title">
                  <h3>İlçe Düzenle ({{ name }})</h3>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="male_title">Başlık</label>
                      <input class="form-control custom-input" v-model="male_title">
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="male_keywords">Meta Keywords</label>
                      <textarea class="form-control custom-input" v-model="male_keywords" rows="5"></textarea>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="male_description">Meta Description</label>
                      <textarea
                        class="form-control custom-input"
                        v-model="male_description"
                        rows="5"
                      ></textarea>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="male_spot">Spot</label>
                      <vue-editor :editorToolbar="customToolbar" v-model="male_spot" class="editor"></vue-editor>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </tab>
      <tab name="Kız Öğr. SEO">
        <div class="row">
          <div class="col-md-12">
            <div class="widget">
              <div class="form-elements-sec">
                <div class="widget-title">
                  <h3>İlçe Düzenle ({{ name }})</h3>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="female_title">Başlık</label>
                      <input class="form-control custom-input" v-model="female_title">
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="female_keywords">Meta Keywords</label>
                      <textarea
                        class="form-control custom-input"
                        v-model="female_keywords"
                        rows="5"
                      ></textarea>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="female_description">Meta Description</label>
                      <textarea
                        class="form-control custom-input"
                        v-model="female_description"
                        rows="5"
                      ></textarea>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="female_spot">Spot</label>
                      <vue-editor :editorToolbar="customToolbar" v-model="female_spot" class="editor"></vue-editor>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </tab>
    </tabs>
    <div class="row">
      <div class="col-md-12">
        <div class="widget text-center">
          <div class="form-elements-sec">
            <button class="btn btn-success" @click="updateData">Kaydet</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";

export default {
  components: { VueEditor },
  data() {
    return {
      isReady: false,
      customToolbar: [
        ['bold', 'italic', 'underline'],
        [{ 'list': 'ordered'}, { 'list': 'bullet' }]
      ],
      id: this.$route.params.id,
      api: "districts/",
      cities: [],
      city: "",
      image: "",
      icon: "",
      name: "",
      slug: "",
      title: "",
      keywords: "",
      description: "",
      spot: "",
      content: "",
      list_seo: "",
      male_title: "",
      male_keywords: "",
      male_description: "",
      male_spot: "",
      female_title: "",
      female_keywords: "",
      female_description: "",
      female_spot: ""
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.axios.get(this.api + this.id + "/edit").then(response => {
        this.name = response.data.district.name;
        this.slug = response.data.district.slug;
        this.keywords = response.data.district.keywords;
        this.description = response.data.district.description;
        this.content = response.data.district.content;
        this.cities = response.data.cities;
        this.spot = response.data.district.spot;
        this.title = response.data.district.title;
        this.list_seo = response.data.district.list_seo;
        this.male_title = response.data.district.male_title;
        this.male_keywords = response.data.district.male_keywords;
        this.male_description = response.data.district.male_description;
        this.male_spot = response.data.district.male_spot;
        this.female_title = response.data.district.female_title;
        this.female_keywords = response.data.district.female_keywords;
        this.female_description = response.data.district.female_description;
        this.female_spot = response.data.district.female_spot;
      }).then(() => {
        this.isReady = true;
      });
    },
    updateData() {
      let data = {
        city: this.city || '' ,
        name: this.name || '' ,
        slug: this.slug || '' ,
        title: this.title || '' ,
        keywords: this.keywords || '' ,
        description: this.description || '' ,
        spot: this.spot || '' ,
        content: this.content || '' ,
        list_seo: this.list_seo || '' ,
        male_title: this.male_title || '' ,
        male_keywords: this.male_keywords || '' ,
        male_description: this.male_description || '' ,
        male_spot: this.male_spot || '' ,
        female_title: this.female_title || '' ,
        female_keywords: this.female_keywords || '' ,
        female_description: this.female_description || '' ,
        female_spot: this.female_spot || '' ,
      };
      const formData = new FormData();
      formData.append("_method", "PUT");
      Object.keys(data).map(e => {
        formData.append(e, data[e]);
      });
      this.$Progress.start();
      // eslint-disable-next-line no-unused-vars
      this.axios.post(this.api + this.id, formData).then(response => {
        // console.log(response);
        this.$Progress.finish();
      });
    },
    onIcon() {
      this.icon = event.target.files[0];
      // console.log(this.icon);
    },
    onImage() {
      this.image = event.target.files[0];
      // console.log(this.image);
    }
  }
};
</script>

<style scoped>
</style>
